import { enFaqs } from '../content/faqs';
export default function Faq() {
 return <section id="faq" className="studio-faq"><div className="studio-shell faq-layout"><div><p className="studio-eyebrow">A few useful answers</p><h2>Questions about<br />working with us.</h2></div><div className="faq-list">{enFaqs.map(([question, answer]) => <details key={question}><summary>{question}<span aria-hidden="true">+</span></summary><p>{answer}</p></details>)}</div></div></section>;
}
